export const BANNED_LIBRARIES = [
  'angularjs.1.0.2.angular.js',
  'angularjs.1.0.2.angular.min.js',
  'angularjs.1.0.3.angular.js',
  'angularjs.1.0.3.angular.min.js',
  'angularjs.1.0.4.angular.js',
  'angularjs.1.0.4.angular.min.js',
  'angularjs.1.0.5.angular.js',
  'angularjs.1.0.5.angular.min.js',
  'angularjs.1.0.6.angular.js',
  'angularjs.1.0.6.angular.min.js',
  'angularjs.1.0.7.angular.js',
  'angularjs.1.0.7.angular.min.js',
  'angularjs.1.0.8.angular.js',
  'angularjs.1.0.8.angular.min.js',
  'angularjs.1.1.0.angular.js',
  'angularjs.1.1.0.angular.min.js',
  'angularjs.1.1.1.angular.js',
  'angularjs.1.1.1.angular.min.js',
  'angularjs.1.1.2.angular.js',
  'angularjs.1.1.2.angular.min.js',
  'angularjs.1.1.3.angular.js',
  'angularjs.1.1.3.angular.min.js',
  'angularjs.1.1.4.angular.js',
  'angularjs.1.1.4.angular.min.js',
  'angularjs.1.1.5.angular.js',
  'angularjs.1.1.5.angular.min.js',
  'angularjs.1.2.0.angular.js',
  'angularjs.1.2.0.angular.min.js',
  'angularjs.1.2.1.angular.js',
  'angularjs.1.2.1.angular.min.js',
  'angularjs.1.2.2.angular.js',
  'angularjs.1.2.2.angular.min.js',
  'angularjs.1.2.3.angular.js',
  'angularjs.1.2.3.angular.min.js',
  'angularjs.1.2.4.angular.js',
  'angularjs.1.2.4.angular.min.js',
  'angularjs.1.2.5.angular.js',
  'angularjs.1.2.5.angular.min.js',
  'angularjs.1.2.6.angular.js',
  'angularjs.1.2.6.angular.min.js',
  'angularjs.1.2.7.angular.js',
  'angularjs.1.2.7.angular.min.js',
  'angularjs.1.2.8.angular.js',
  'angularjs.1.2.8.angular.min.js',
  'angularjs.1.2.9.angular.js',
  'angularjs.1.2.9.angular.min.js',
  'angularjs.1.2.10.angular.js',
  'angularjs.1.2.10.angular.min.js',
  'angularjs.1.2.11.angular.js',
  'angularjs.1.2.11.angular.min.js',
  'angularjs.1.2.12.angular.js',
  'angularjs.1.2.12.angular.min.js',
  'angularjs.1.2.13.angular.js',
  'angularjs.1.2.13.angular.min.js',
  'angularjs.1.2.14.angular.js',
  'angularjs.1.2.14.angular.min.js',
  'angularjs.1.2.15.angular.js',
  'angularjs.1.2.15.angular.min.js',
  'angularjs.1.2.16.angular.js',
  'angularjs.1.2.16.angular.min.js',
  'angularjs.1.2.17.angular.js',
  'angularjs.1.2.17.angular.min.js',
  'angularjs.1.2.18.angular.js',
  'angularjs.1.2.18.angular.min.js',
  'angularjs.1.2.19.angular.js',
  'angularjs.1.2.19.angular.min.js',
  'angularjs.1.2.20.angular.js',
  'angularjs.1.2.20.angular.min.js',
  'angularjs.1.2.21.angular.js',
  'angularjs.1.2.21.angular.min.js',
  'angularjs.1.2.22.angular.js',
  'angularjs.1.2.22.angular.min.js',
  'angularjs.1.2.23.angular.js',
  'angularjs.1.2.23.angular.min.js',
  'angularjs.1.2.24.angular.js',
  'angularjs.1.2.24.angular.min.js',
  'angularjs.1.2.25.angular.js',
  'angularjs.1.2.25.angular.min.js',
  'angularjs.1.2.26.angular.js',
  'angularjs.1.2.26.angular.min.js',
  'angularjs.1.2.27.angular.js',
  'angularjs.1.2.27.angular.min.js',
  'angularjs.1.2.28.angular.js',
  'angularjs.1.2.28.angular.min.js',
  'angularjs.1.2.29.angular.js',
  'angularjs.1.2.29.angular.min.js',
  'angularjs.1.2.30.angular.js',
  'angularjs.1.2.30.angular.min.js',
  'angularjs.1.3.0.angular.js',
  'angularjs.1.3.0.angular.min.js',
  'angularjs.1.3.1.angular.js',
  'angularjs.1.3.1.angular.min.js',
  'angularjs.1.3.2.angular.js',
  'angularjs.1.3.2.angular.min.js',
  'angularjs.1.3.3.angular.js',
  'angularjs.1.3.3.angular.min.js',
  'angularjs.1.3.4.angular.js',
  'angularjs.1.3.4.angular.min.js',
  'angularjs.1.3.5.angular.js',
  'angularjs.1.3.5.angular.min.js',
  'angularjs.1.3.6.angular.js',
  'angularjs.1.3.6.angular.min.js',
  'angularjs.1.3.7.angular.js',
  'angularjs.1.3.7.angular.min.js',
  'angularjs.1.3.8.angular.js',
  'angularjs.1.3.8.angular.min.js',
  'angularjs.1.3.9.angular.js',
  'angularjs.1.3.9.angular.min.js',
  'angularjs.1.3.10.angular.js',
  'angularjs.1.3.10.angular.min.js',
  'angularjs.1.3.11.angular.js',
  'angularjs.1.3.11.angular.min.js',
  'angularjs.1.3.12.angular.js',
  'angularjs.1.3.12.angular.min.js',
  'angularjs.1.3.13.angular.js',
  'angularjs.1.3.13.angular.min.js',
  'angularjs.1.3.14.angular.js',
  'angularjs.1.3.14.angular.min.js',
  'angularjs.1.3.15.angular.js',
  'angularjs.1.3.15.angular.min.js',
  'angularjs.1.3.16.angular.js',
  'angularjs.1.3.16.angular.min.js',
  'angularjs.1.3.17.angular.js',
  'angularjs.1.3.17.angular.min.js',
  'angularjs.1.3.18.angular.js',
  'angularjs.1.3.18.angular.min.js',
  'angularjs.1.3.19.angular.js',
  'angularjs.1.3.19.angular.min.js',
  'angularjs.1.3.20.angular.js',
  'angularjs.1.3.20.angular.min.js',
  'angularjs.1.4.0.angular.js',
  'angularjs.1.4.0.angular.min.js',
  'angularjs.1.4.1.angular.js',
  'angularjs.1.4.1.angular.min.js',
  'angularjs.1.4.2.angular.js',
  'angularjs.1.4.2.angular.min.js',
  'angularjs.1.4.3.angular.js',
  'angularjs.1.4.3.angular.min.js',
  'angularjs.1.4.4.angular.js',
  'angularjs.1.4.4.angular.min.js',
  'angularjs.1.4.5.angular.js',
  'angularjs.1.4.5.angular.min.js',
  'angularjs.1.4.6.angular.js',
  'angularjs.1.4.6.angular.min.js',
  'angularjs.1.4.7.angular.js',
  'angularjs.1.4.7.angular.min.js',
  'angularjs.1.4.8.angular.js',
  'angularjs.1.4.8.angular.min.js',
  'angularjs.1.4.9.angular.js',
  'angularjs.1.4.9.angular.min.js',
  'angularjs.1.4.10.angular.js',
  'angularjs.1.4.10.angular.min.js',
  'angularjs.1.4.11.angular.js',
  'angularjs.1.4.11.angular.min.js',
  'angularjs.1.4.12.angular.js',
  'angularjs.1.4.12.angular.min.js',
  'angularjs.1.5.0.angular.js',
  'angularjs.1.5.0.angular.min.js',
  'angularjs.1.5.1.angular.js',
  'angularjs.1.5.1.angular.min.js',
  'angularjs.1.5.2.angular.js',
  'angularjs.1.5.2.angular.min.js',
  'angularjs.1.5.3.angular.js',
  'angularjs.1.5.3.angular.min.js',
  'angularjs.1.5.4.angular.js',
  'angularjs.1.5.4.angular.min.js',
  'angularjs.1.5.5.angular.js',
  'angularjs.1.5.5.angular.min.js',
  'angularjs.1.5.6.angular.js',
  'angularjs.1.5.6.angular.min.js',
  'angularjs.1.5.7.angular.js',
  'angularjs.1.5.7.angular.min.js',
  'angularjs.1.5.8.angular.js',
  'angularjs.1.5.8.angular.min.js',
  'angularjs.1.5.9.angular.js',
  'angularjs.1.5.9.angular.min.js',
  'angularjs.1.6.0.angular.js',
  'angularjs.1.6.0.angular.min.js',
  'angularjs.1.6.1.angular.js',
  'angularjs.1.6.1.angular.min.js',
  'angularjs.1.6.2.angular.js',
  'angularjs.1.6.2.angular.min.js',
  'angularjs.1.6.3.angular.js',
  'angularjs.1.6.3.angular.min.js',
  'angularjs.1.6.4.angular.js',
  'angularjs.1.6.4.angular.min.js',
  'angularjs.1.6.5.angular.js',
  'angularjs.1.6.5.angular.min.js',
  'angularjs.1.6.6.angular.js',
  'angularjs.1.6.6.angular.min.js',
  'angularjs.1.6.7.angular.js',
  'angularjs.1.6.7.angular.min.js',
  'angularjs.1.6.8.angular.js',
  'angularjs.1.6.8.angular.min.js',
  'angularjs.1.6.9.angular.js',
  'angularjs.1.6.9.angular.min.js',
  'angularjs.1.6.10.angular.js',
  'angularjs.1.6.10.angular.min.js',
  'angularjs.1.7.0.angular.js',
  'angularjs.1.7.0.angular.min.js',
  'angularjs.1.7.1.angular.js',
  'angularjs.1.7.1.angular.min.js',
  'jquery.1.2.1.jquery.js',
  'jquery.1.2.1.jquery.min.js',
  'jquery.1.2.2.jquery.js',
  'jquery.1.2.2.jquery.min.js',
  'jquery.1.2.3.jquery.js',
  'jquery.1.2.3.jquery.min.js',
  'jquery.1.2.4.jquery.js',
  'jquery.1.2.4.jquery.min.js',
  'jquery.1.2.5.jquery.js',
  'jquery.1.2.5.jquery.min.js',
  'jquery.1.2.6.jquery.js',
  'jquery.1.2.6.jquery.min.js',
  'jquery.1.2.jquery.js',
  'jquery.1.2.jquery.min.js',
  'jquery.1.3.1.jquery.js',
  'jquery.1.3.1.jquery.min.js',
  'jquery.1.3.2.jquery.js',
  'jquery.1.3.2.jquery.min.js',
  'jquery.1.3.jquery.js',
  'jquery.1.3.jquery.min.js',
  'jquery.1.4.1.jquery.js',
  'jquery.1.4.1.jquery.min.js',
  'jquery.1.4.2.jquery.js',
  'jquery.1.4.2.jquery.min.js',
  'jquery.1.4.3.jquery.js',
  'jquery.1.4.3.jquery.min.js',
  'jquery.1.4.4.jquery.js',
  'jquery.1.4.4.jquery.min.js',
  'jquery.1.4.jquery.js',
  'jquery.1.4.jquery.min.js',
  'jquery.1.5.1.jquery.js',
  'jquery.1.5.1.jquery.min.js',
  'jquery.1.5.2.jquery.js',
  'jquery.1.5.2.jquery.min.js',
  'jquery.1.5.jquery.js',
  'jquery.1.5.jquery.min.js',
  'jquery.1.6.1.jquery.js',
  'jquery.1.6.1.jquery.min.js',
  'jquery.1.6.2.jquery.js',
  'jquery.1.6.2.jquery.min.js',
  'jquery.1.6.3.jquery.js',
  'jquery.1.6.3.jquery.min.js',
  'jquery.1.6.4.jquery.js',
  'jquery.1.6.4.jquery.min.js',
  'jquery.1.6.jquery.js',
  'jquery.1.6.jquery.min.js',
  'jquery.1.7.0.jquery.js',
  'jquery.1.7.0.jquery.min.js',
  'jquery.1.7.1.jquery.js',
  'jquery.1.7.1.jquery.min.js',
  'jquery.1.7.2.jquery.js',
  'jquery.1.7.2.jquery.min.js',
  'jquery.1.8.0.jquery.js',
  'jquery.1.8.0.jquery.min.js',
  'jquery.1.8.1.jquery.js',
  'jquery.1.8.1.jquery.min.js',
  'jquery.1.8.2.jquery.js',
  'jquery.1.8.2.jquery.min.js',
  'jquery.1.8.3.jquery.js',
  'jquery.1.8.3.jquery.min.js',
  'jquery.1.9.0.jquery.js',
  'jquery.1.9.0.jquery.min.js',
  'jquery.1.9.1.jquery.js',
  'jquery.1.9.1.jquery.min.js',
  'jquery.1.10.0.jquery.js',
  'jquery.1.10.0.jquery.min.js',
  'jquery.1.10.1.jquery.js',
  'jquery.1.10.1.jquery.min.js',
  'jquery.1.10.2.jquery.js',
  'jquery.1.10.2.jquery.min.js',
  'jquery.1.11.0.jquery.js',
  'jquery.1.11.0.jquery.min.js',
  'jquery.1.11.1.jquery.js',
  'jquery.1.11.1.jquery.min.js',
  'jquery.1.11.2.jquery.js',
  'jquery.1.11.2.jquery.min.js',
  'jquery.1.11.3.jquery.js',
  'jquery.1.11.3.jquery.min.js',
  'jquery.1.12.0.jquery.js',
  'jquery.1.12.0.jquery.min.js',
  'jquery.1.12.1.jquery.js',
  'jquery.1.12.1.jquery.min.js',
  'jquery.1.12.2.jquery.js',
  'jquery.1.12.2.jquery.min.js',
  'jquery.1.12.3.jquery.js',
  'jquery.1.12.3.jquery.min.js',
  'jquery.1.12.4.jquery.js',
  'jquery.1.12.4.jquery.min.js',
];

export const UNADVISED_LIBRARIES = [
  'jquery.2.0.0.jquery.js',
  'jquery.2.0.0.jquery.min.js',
  'jquery.2.0.1.jquery.js',
  'jquery.2.0.1.jquery.min.js',
  'jquery.2.0.2.jquery.js',
  'jquery.2.0.2.jquery.min.js',
  'jquery.2.0.3.jquery.js',
  'jquery.2.0.3.jquery.min.js',
  'jquery.2.1.0.jquery.js',
  'jquery.2.1.0.jquery.min.js',
  'jquery.2.1.1.jquery.js',
  'jquery.2.1.1.jquery.min.js',
  'jquery.2.1.2.jquery.js',
  'jquery.2.1.2.jquery.min.js',
  'jquery.2.1.3.jquery.js',
  'jquery.2.1.3.jquery.min.js',
  'jquery.2.1.4.jquery.js',
  'jquery.2.1.4.jquery.min.js',
  'jquery.2.2.0.jquery.js',
  'jquery.2.2.0.jquery.min.js',
  'jquery.2.2.1.jquery.js',
  'jquery.2.2.1.jquery.min.js',
  'jquery.2.2.2.jquery.js',
  'jquery.2.2.2.jquery.min.js',
  'jquery.2.2.3.jquery.js',
  'jquery.2.2.3.jquery.min.js',
  'jquery.2.2.4.jquery.js',
  'jquery.2.2.4.jquery.min.js',
];
